import React from "react"
import Formato from "./Formato"
import MasterDataProduto from "./MasterData/produto"
import MasterDataCanal from "./MasterData/canal"
import MasterDataPlanejamento from "./MasterData/planejamento"

// export default [
//   <Route
//     path="/captura/manual"
//     exact
//     component={(props) => <Manual {...props} />}
//   />,
//   <Route
//     path="/captura/automacao"
//     exact
//     component={(props) => <Automacao {...props} />}
//   />,
// ]

export default [
  {
    path: "/repo/format",
    component: Formato,
  },
  {
    path: "/repo/master-data",
    component: MasterDataProduto,
  },
  {
    path: "/repo/master-data/canal",
    component: MasterDataCanal,
  },
  {
    path: "/repo/master-data/planejamento",
    component: MasterDataPlanejamento,
  },
]
